import {Component, OnInit, OnDestroy} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Headers, Http, RequestOptions} from '@angular/http';
import {Constants} from '../../constants';
import {Subscription} from 'rxjs/Subscription';

@Component({
  selector: 'app-email-validation',
  templateUrl: './email-validation.component.html',
  styleUrls: ['./email-validation.component.css']
})
export class EmailValidationComponent implements OnInit, OnDestroy {

  token: string;
    id: string;
  sub: Subscription;

  constructor(private route: ActivatedRoute,
              private _http: Http,
              private _router: Router) {
  }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
        console.log(params);
      this.token = params[Constants.TOKEN];
        this.id = params[Constants.ID];
    });
      if(this.id){
          this.validateUpdateEmail();
      } else{
          this.validateEmail();
      }
  }

    ngOnDestroy(){
        this.sub.unsubscribe();
    }

  private validateEmail() {
    const emailVerificationUrl = Constants.NEXPRESS_ENDPOINT + 'Email/ValidateEmail';
    const data: string = JSON.stringify({Key: this.token});
    const headers = new Headers({
      'Content-Type': 'application/JSON'
    });
    const options = new RequestOptions({headers: headers});
    this._http.post(emailVerificationUrl, data, options)
      .map((response) => response.json())
      .subscribe(
        result => {
          this._router.navigateByUrl('/emailsuccess');
        },
        error => console.log('Error: ' + JSON.stringify(error))
      );
  }

  private validateUpdateEmail() {
    const emailVerificationUrl = Constants.NEXPRESS_ENDPOINT + 'Email/ConfirmUpdateEmail';
      const data: string = JSON.stringify({UpdateEmailGuid: this.token, AccountId: this.id});
    const headers = new Headers({
      'Content-Type': 'application/JSON'
    });
    const options = new RequestOptions({headers: headers});
    this._http.post(emailVerificationUrl, data, options)
      .map((response) => response.json())
      .subscribe(
        result => {
          this._router.navigateByUrl('/emailsuccess');
        },
        error => console.log('Error: ' + JSON.stringify(error))
      );
  }
}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/email-validation/email-validation.component.ts